import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './perfilAcessoForm';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';
import InputPesquisa from '../common/form/inputPesquisa';
import Aguardando from '../common/template/aguardando';
import ReactExport from 'react-export-excel-fixed-xlsx';

import {
	setModoTela,
	initForm,
	salvar,
	excluir,
	getLista,
	getListaModulo
} from './perfilAcessoActions';

class PerfilAcesso extends Component {

	state = {
		linhaSelecionada: null,
		pesquisar: '',
		ordenacao: {
			nome: 1
		}
	}

	componentWillMount() {
		this.props.setModoTela('lista');
		this.props.getLista();
		this.props.getListaModulo();
	}

	render() {
		return (
			<div>
				<Content>

					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}

					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}

					{this.props.modoTela == 'lista' ? this.lista() : null}

				</Content>
			</div>
		)
	}

	getNovaOrdenacao(atual) {
		return atual == 2 ? 0 : (atual || 0) + 1;
	}

	getIconeOrdenacao(tipo) {
		if (tipo == 1) {
			return <i className='fas fa-sort-amount-down-alt' />;
		} else if (tipo == 2) {
			return <i className='fas fa-sort-amount-up' />;
		} else {
			return null;
		}
	}

	lista() {

		const ExcelFile = ReactExport.ExcelFile;
		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		let lista = (this.props.lista || []).filter(item => {

			return !(this.state.pesquisar || '').trim()
				|| (this.state.pesquisar.toUpperCase() || '')
					.split('+')
					.filter(pesquisar => (pesquisar || '').trim())
					.filter(pesquisar => {

						if (
							pesquisar
							&& !(`${item.nome || ''}`)
								.toUpperCase()
								.includes(pesquisar)
						) {
							return false;
						}

						return true;

					}).length > 0;

		});

		if (this.state.ordenacao.nome) {

			lista.sort((a, b) =>
				this.state.ordenacao.nome == 1
					? ((a.nome || '') > (b.nome || '') ? 1 : -1)
					: ((a.nome || '') > (b.nome || '') ? -1 : 1)
			);
		}

		return (
			<ContentCard>

				<ContentCardBody>

					<Row>

						<InputPesquisa
							maxWidth={350}
							minWidth={350}
							cols='12 12 12 12'
							label='Pesquisar'
							value={this.state.pesquisar}
							onChange={value =>
								this.setState({
									...this.state,
									pesquisar: value
								})
							}
						/>

						<div
							style={{
								width: 310,
								marginTop: 8,
								marginLeft: 8
							}}
						>

							<a
								className='btn btn-app bg-primary'
								style={{
									marginLeft: 2,
									minWidth: 75
								}}
								onClick={() => {
									this.props.getLista();
								}}
							>
								<i className='fas fa-sync-alt'></i>
								{' '}Atualizar
							</a>

							<a
								className='btn btn-app bg-primary'
								style={{
									marginLeft: 2,
									minWidth: 75
								}}
								onClick={() => {

									const registro = {
										json_acesso: []
									};

									this.props.setModoTela(
										'cadastro',
										registro
									);

									this.props.initForm(
										registro
									);
								}}
							>
								<i className='fas fa-plus'></i>
								{' '}Adicionar
							</a>

							<ExcelFile
								filename={'Perfis de Acesso'}
								element={
									<a
										className='btn btn-app bg-success'
										style={{
											marginLeft: 2,
											minWidth: 75
										}}
									>
										<i className='fas fa-file-excel'></i>
										{' '}Exportar
									</a>
								}
							>

								<ExcelSheet
									data={lista.map(item => ({
										...item
									}))}
									name='Perfis de Acesso'
								>

									<ExcelColumn
										label='Nome'
										value='nome'
									/>

								</ExcelSheet>

							</ExcelFile>

						</div>

					</Row>

					<div
						style={{
							backgroundColor: '#1F3066',
							marginLeft: -8,
							marginRight: -8,
							marginBottom: -8,
							paddingTop: 1,
							paddingLeft: 8,
							paddingRight: 8,
							paddingBottom: 8,
							height: window.innerWidth < 768
								? '100%'
								: (
									window.innerWidth < 1093
										? `${window.innerHeight - 300}px`
										: (
											window.innerWidth < 1799
												? `${window.innerHeight - 180}px`
												: (
													window.innerWidth < 4000
														? `${window.innerHeight - 180}px`
														: `${window.innerHeight - 110}px`
												)
										)
								)
						}}
					>

						<Table
							responsive
							border
							striped
							alturaFixa
							maxHeight={
								window.innerWidth < 768
									? '100%'
									: (
										window.innerWidth < 1093
											? `${window.innerHeight - 300}px`
											: (
												window.innerWidth < 1799
													? `${window.innerHeight - 180}px`
													: (
														window.innerWidth < 4000
															? `${window.innerHeight - 180}px`
															: `${window.innerHeight - 110}px`
													)
											)
									)
							}
						>

							<THead>

								<Tr
									backgroundColor={'#1F3066'}
									color={'#ffffff'}
									height={47}
								>

									<Th
										paddingTop={2}
										paddingBottom={2}
										onClick={() =>
											this.setState({
												...this.state,
												ordenacao: {
													nome: this.getNovaOrdenacao(
														this.state.ordenacao.nome
													)
												}
											})
										}
										sticky
										backgroundColor={'#1F3066'}
										color={'#ffffff'}
										alignLeft
									>
										Nome {this.getIconeOrdenacao(
											this.state.ordenacao.nome
										)}
									</Th>

									<Th
										minWidth={120}
										width={120}
										paddingTop={2}
										paddingBottom={2}
										sticky
										backgroundColor={'#1F3066'}
										color={'#ffffff'}
										alignCenter
									>
									</Th>

								</Tr>

							</THead>

							<TBody>

								{lista.map((item, i) => (

									<Tr
										key={item.id}
										backgroundColor={
											this.state.linhaSelecionada == item.id
												? '#bcc7eb'
												: (
													i % 2 == 0
														? '#ffffff'
														: '#f5f5f5'
												)
										}
										onClick={() =>
											this.setState({
												...this.state,
												linhaSelecionada: item.id
											})
										}
									>

										<Td
											color={'#000'}
											alignLeft
											small
										>
											{item.nome}
										</Td>

										<Td
											minWidth={120}
											width={120}
											alignCenter
										>

											<ButtonTable
												type={'warning'}
												icon={'fas fa-pencil-alt'}
												visible={true}
												small
												title='Editar'
												event={() => {

													this.props.setModoTela(
														'cadastro',
														{
															...item
														}
													);

													this.props.initForm({
														...item
													});
												}}
											/>

											<ButtonTable
												type={'danger'}
												icon={'fas fa-trash-alt'}
												visible={true}
												small
												title='Excluir'
												event={() => {

													this.props.setModoTela(
														'exclusao',
														{
															...item
														}
													);

													this.props.initForm({
														...item
													});
												}}
											/>

										</Td>

									</Tr>

								))}

							</TBody>

						</Table>

					</div>

				</ContentCardBody>

			</ContentCard>
		);
	}
}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	aguardando: state.perfilAcesso.aguardando,
	modoTela: state.perfilAcesso.modoTela,
	lista: state.perfilAcesso.lista
});

const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela,
	initForm,
	salvar,
	excluir,
	getLista,
	getListaModulo
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(PerfilAcesso);
